const CustomObject = {
  path: "",
  name: "",
  redirect: "/custom-object",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/custom-object",
      redirect: "/custom-object",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Custom Object",
      meta: {
        requiresAuth: true,
        activeUrl: "/custom-object",
        parent: "/custom-object",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/customObject"),
          meta: {
            requiresAuth: true,
            activeUrl: "/custom-object",
            parent: "/custom-object",

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Custom Object Detail",
          component: () => import("@/views/pages/customObject/detail"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/custom-object",
            parent: "/custom-object",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default CustomObject;
